var _symbol, _symbol2, _symbol3, _symbol4, _path, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "add_broker",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4383 13.5728L11.0092 12.7518L10.534 12.4214L10.0108 12.6688L10.4383 13.5728ZM19.5617 13.5728L19.9892 12.6688L19.466 12.4214L18.9909 12.7518L19.5617 13.5728ZM8 19C8 17.0038 9.16982 15.2788 10.8657 14.4768L10.0108 12.6688C7.64206 13.7888 6 16.2017 6 19H8ZM9 20C8.44772 20 8 19.5523 8 19H6C6 20.6569 7.34315 22 9 22V20ZM15 20H9V22H15V20ZM21 20H15V22H21V20ZM22 19C22 19.5523 21.5523 20 21 20V22C22.6569 22 24 20.6569 24 19H22ZM19.1343 14.4768C20.8302 15.2788 22 17.0038 22 19H24C24 16.2017 22.3579 13.7888 19.9892 12.6688L19.1343 14.4768ZM18.9909 12.7518C17.859 13.5388 16.4849 14 15 14V16C16.9061 16 18.6765 15.4063 20.1326 14.3938L18.9909 12.7518ZM15 14C13.5151 14 12.141 13.5388 11.0092 12.7518L9.86737 14.3938C11.3235 15.4063 13.0939 16 15 16V14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 7,
    r: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7V13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10L1 10",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17L13 15H17L15.5 17L17 20H13L14.5 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "add_user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4383 13.5728L11.0092 12.7517L10.534 12.4213L10.0108 12.6687L10.4383 13.5728ZM19.5617 13.5728L19.9892 12.6687L19.466 12.4213L18.9909 12.7517L19.5617 13.5728ZM8 18.9999C8 17.0037 9.16982 15.2787 10.8657 14.4768L10.0108 12.6687C7.64206 13.7888 6 16.2016 6 18.9999H8ZM9 19.9999C8.44772 19.9999 8 19.5522 8 18.9999H6C6 20.6568 7.34315 21.9999 9 21.9999V19.9999ZM15 19.9999H9V21.9999H15V19.9999ZM21 19.9999H15V21.9999H21V19.9999ZM22 18.9999C22 19.5522 21.5523 19.9999 21 19.9999V21.9999C22.6569 21.9999 24 20.6568 24 18.9999H22ZM19.1343 14.4768C20.8302 15.2787 22 17.0037 22 18.9999H24C24 16.2016 22.3579 13.7888 19.9892 12.6687L19.1343 14.4768ZM18.9909 12.7517C17.859 13.5387 16.4849 13.9999 15 13.9999V15.9999C16.9061 15.9999 18.6765 15.4063 20.1326 14.3938L18.9909 12.7517ZM15 13.9999C13.5151 13.9999 12.141 13.5387 11.0092 12.7517L9.86737 14.3938C11.3235 15.4063 13.0939 15.9999 15 15.9999V13.9999Z",
    fill: "black",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 7,
    r: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7V13",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10L1 10",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "arrow_down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9L12 16L19 9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "arrow_left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2793 12.2071L5.2793 12.2071",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2793 17.2071L5.2793 12.2071L10.2793 7.20714",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 426.667 426.667",
    style: {
      enableBackground: "new 0 0 426.667 426.667"
    },
    xmlSpace: "preserve",
    id: "check",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.876,56.307c-6.548-6.78-17.352-6.968-24.132-0.42c-0.142,0.137-0.282,0.277-0.42,0.42L119.257,334.375    l-90.334-90.334c-6.78-6.548-17.584-6.36-24.132,0.42c-6.388,6.614-6.388,17.099,0,23.713l102.4,102.4    c6.665,6.663,17.468,6.663,24.132,0L421.456,80.44C428.236,73.891,428.424,63.087,421.876,56.307z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "check_orange",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12L11.5 16L17 7.5",
    stroke: "#FF7D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17L17 7.00001",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17L7 7",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "edit_filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 14.4142V17H7.58579C7.851 17 8.10536 16.8946 8.29289 16.7071L17.5 7.5C18.3284 6.67157 18.3284 5.32843 17.5 4.5C16.6716 3.67157 15.3284 3.67157 14.5 4.5L5.29289 13.7071C5.10536 13.8946 5 14.149 5 14.4142Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6L16 9",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 21H19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "file_text",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4C4 2.89543 4.89543 2 6 2H14.1716C14.702 2 15.2107 2.21071 15.5858 2.58579L19.4142 6.41421C19.7893 6.78929 20 7.29799 20 7.82843V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2V6C14 7.10457 14.8954 8 16 8H20",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 13H16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17H16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "filter",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6H5V9L10 14V21L14 19V14L19 9V6Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 21H5C3.34315 21 2 19.6569 2 18V5C2 3.89543 2.89543 3 4 3H8.92963C9.59834 3 10.2228 3.3342 10.5937 3.8906L11.4063 5.1094C11.7772 5.6658 12.4017 6 13.0704 6H17C18.6569 6 20 7.34315 20 9V10",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52127 11.3165C5.80868 10.5261 6.55984 10 7.40085 10H20.1446C21.5325 10 22.4985 11.3791 22.0242 12.6835L19.7181 19.0252C19.287 20.2108 18.1602 21 16.8987 21H4.8554C3.46747 21 2.5015 19.6209 2.97581 18.3165L5.52127 11.3165Z",
    stroke: "black",
    strokeWidth: 2
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "globe",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM4 12C4 11.101 4.156 10.238 4.431 9.431L6 11L8 13V15L10 17L11 18V19.931C7.061 19.436 4 16.072 4 12ZM18.33 16.873C17.677 16.347 16.687 16 16 16V15C16 14.4696 15.7893 13.9609 15.4142 13.5858C15.0391 13.2107 14.5304 13 14 13H10V10C10.5304 10 11.0391 9.78929 11.4142 9.41421C11.7893 9.03914 12 8.53043 12 8V7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5V4.589C17.928 5.778 20 8.65 20 12C19.9998 13.7647 19.4123 15.4791 18.33 16.873Z",
    fill: "black"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "none",
    id: "key",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6688 12.5064L14.2345 11.6057C13.7813 11.8242 13.561 12.3453 13.7201 12.8226L14.6688 12.5064ZM10.5 12.584H11.5C11.5 12.1865 11.2646 11.8267 10.9004 11.6676L10.5 12.584ZM10.5 21H9.5C9.5 21.2652 9.60535 21.5196 9.79288 21.7071L10.5 21ZM12 22.5001L11.2929 23.2072C11.4804 23.3947 11.7348 23.5001 12 23.5001C12.2652 23.5001 12.5196 23.3947 12.7071 23.2072L12 22.5001ZM15 19.5L15.7071 20.2071C16.0976 19.8166 16.0976 19.1834 15.7071 18.7929L15 19.5ZM13.5 18L12.7929 17.2929C12.6054 17.4804 12.5 17.7348 12.5 18C12.5 18.2652 12.6054 18.5196 12.7929 18.7071L13.5 18ZM15 16.5001L15.7071 17.2072C15.8946 17.0196 16 16.7653 16 16.5001C16 16.2349 15.8946 15.9805 15.7071 15.793L15 16.5001ZM13.5 15.0001L12.7929 14.293C12.4024 14.6835 12.4024 15.3166 12.7929 15.7072L13.5 15.0001ZM15 13.5L15.7071 14.2071C15.9749 13.9393 16.0685 13.5431 15.9487 13.1838L15 13.5ZM16.5 8C16.5 9.58598 15.5771 10.9583 14.2345 11.6057L15.1031 13.4072C17.111 12.4391 18.5 10.3827 18.5 8H16.5ZM12.5 4C14.7091 4 16.5 5.79086 16.5 8H18.5C18.5 4.68629 15.8137 2 12.5 2V4ZM8.5 8C8.5 5.79086 10.2909 4 12.5 4V2C9.18629 2 6.5 4.68629 6.5 8H8.5ZM10.9004 11.6676C9.48556 11.0494 8.5 9.6387 8.5 8H6.5C6.5 10.4619 7.98263 12.5754 10.0996 13.5003L10.9004 11.6676ZM11.5 21V12.584H9.5V21H11.5ZM12.7071 21.793L11.2071 20.2929L9.79288 21.7071L11.2929 23.2072L12.7071 21.793ZM14.2929 18.7929L11.2929 21.793L12.7071 23.2072L15.7071 20.2071L14.2929 18.7929ZM12.7929 18.7071L14.2929 20.2071L15.7071 18.7929L14.2071 17.2929L12.7929 18.7071ZM14.2929 15.7929L12.7929 17.2929L14.2071 18.7071L15.7071 17.2072L14.2929 15.7929ZM12.7929 15.7072L14.2929 17.2072L15.7071 15.793L14.2071 14.293L12.7929 15.7072ZM14.2929 12.7929L12.7929 14.293L14.2071 15.7072L15.7071 14.2071L14.2929 12.7929ZM13.7201 12.8226L14.0513 13.8162L15.9487 13.1838L15.6175 12.1902L13.7201 12.8226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.4998,
    cy: 7.2,
    r: 1.2,
    fill: "black"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "none",
    id: "nav_admin",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43826 13.5728L8.00915 12.7518L7.53399 12.4214L7.01079 12.6688L7.43826 13.5728ZM16.5617 13.5728L16.9892 12.6688L16.466 12.4214L15.9909 12.7518L16.5617 13.5728ZM5 19C5 17.0038 6.16982 15.2788 7.86573 14.4768L7.01079 12.6688C4.64206 13.7888 3 16.2017 3 19H5ZM6 20C5.44772 20 5 19.5523 5 19H3C3 20.6569 4.34315 22 6 22V20ZM12 20H6V22H12V20ZM18 20H12V22H18V20ZM19 19C19 19.5523 18.5523 20 18 20V22C19.6569 22 21 20.6569 21 19H19ZM16.1343 14.4768C17.8302 15.2788 19 17.0038 19 19H21C21 16.2017 19.3579 13.7888 16.9892 12.6688L16.1343 14.4768ZM15.9909 12.7518C14.859 13.5388 13.4849 14 12 14V16C13.9061 16 15.6765 15.4063 17.1326 14.3938L15.9909 12.7518ZM12 14C10.5151 14 9.14096 13.5388 8.00915 12.7518L6.86737 14.3938C8.3235 15.4063 10.0939 16 12 16V14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17L10 15H14L12.5 17L14 20H10L11.5 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "black"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "nav_translations",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 14H5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14H22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 6L15 6",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 18L15 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18H5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18H22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10H5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6H5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 10H22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6H22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3L15 6L12 9",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 21L9 18L12 15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "notification_error",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#E23009",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15L15 9",
    stroke: "#E23009",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "notification_success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#00AF87",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13L11 16L16 8.5",
    stroke: "#00AF87",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12H19",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19L12 5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "profile_card",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 16,
    rx: 3,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71913 12.2861C4.70297 12.7666 4 13.8011 4 14.9997V15.9997C4 16.552 4.44772 16.9997 5 16.9997H11C11.5523 16.9997 12 16.552 12 15.9997V14.9997C12 13.8011 11.297 12.7666 10.2809 12.2861C9.63389 12.736 8.84774 12.9997 8 12.9997C7.15226 12.9997 6.36611 12.736 5.71913 12.2861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10H19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14H19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "remove",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 4,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16L16 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "role_agent",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14L6.42174 21.1022C6.20531 22.0761 6.94643 23 7.94414 23V23C8.58184 23 9.1553 22.6118 9.39214 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14L15.5783 21.1022C15.7947 22.0761 15.0536 23 14.0559 23V23C13.4182 23 12.8447 22.6118 12.6079 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8533 7.68297L11.6626 7.92638C11.2222 7.97531 10.7778 7.97531 10.3374 7.92638L8.14672 7.68297C7.09234 7.56582 6.03461 7.87231 5.20621 8.53503L4.11731 9.40615C2.72109 10.5231 2.60574 12.6057 3.87008 13.8701L4.75 14.75C5.44036 15.4404 6.55964 15.4404 7.25 14.75C7.94036 14.0596 7.94036 12.9404 7.25 12.25L6.5 11.5L8 11V14H14V11L15.5 11.5L14.75 12.25C14.0596 12.9404 14.0596 14.0596 14.75 14.75C15.4404 15.4404 16.5596 15.4404 17.25 14.75L18.1299 13.8701C19.3943 12.6057 19.2789 10.5231 17.8827 9.40615L16.7938 8.53503C15.9654 7.87231 14.9077 7.56582 13.8533 7.68297Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21H22L18 14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "role_manager",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14L6.42174 21.1022C6.20531 22.0761 6.94643 23 7.94414 23V23C8.58184 23 9.1553 22.6118 9.39214 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14L15.5783 21.1022C15.7947 22.0761 15.0536 23 14.0559 23V23C13.4182 23 12.8447 22.6118 12.6079 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8533 7.68297L11.6626 7.92638C11.2222 7.97531 10.7778 7.97531 10.3374 7.92638L8.14672 7.68297C7.09234 7.56582 6.03461 7.87231 5.20621 8.53503L4.11731 9.40615C2.72109 10.5231 2.60574 12.6057 3.87008 13.8701L4.75 14.75C5.44036 15.4404 6.55964 15.4404 7.25 14.75C7.94036 14.0596 7.94036 12.9404 7.25 12.25L6.5 11.5L8 11V14H14V11L15.5 11.5L14.75 12.25C14.0596 12.9404 14.0596 14.0596 14.75 14.75C15.4404 15.4404 16.5596 15.4404 17.25 14.75L18.1299 13.8701C19.3943 12.6057 19.2789 10.5231 17.8827 9.40615L16.7938 8.53503C15.9654 7.87231 14.9077 7.56582 13.8533 7.68297Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21H22L18 14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "search_input",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7695 17.7695L23 23",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "search_spaced",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 7,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16L20 20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M10.2534 4.47959L9.26701 4.31519V4.31519L10.2534 4.47959ZM13.7466 4.47959L12.7602 4.64399V4.64399L13.7466 4.47959ZM13.8757 5.25414L12.8893 5.41854C12.9532 5.80207 13.2337 6.11378 13.6083 6.21774L13.8757 5.25414ZM15.4432 5.90399L14.9506 6.77425C15.2891 6.96584 15.708 6.9438 16.0245 6.71773L15.4432 5.90399ZM16.0827 5.44724L15.5015 4.6335L16.0827 5.44724ZM18.364 5.63604L19.0711 4.92893V4.92893L18.364 5.63604ZM18.5528 7.9173L17.739 7.33606V7.33606L18.5528 7.9173ZM18.096 8.55676L17.2823 7.97552C17.0562 8.29202 17.0342 8.71089 17.2258 9.04937L18.096 8.55676ZM18.7459 10.1243L17.7823 10.3917C17.8862 10.7663 18.1979 11.0468 18.5815 11.1107L18.7459 10.1243ZM19.5204 10.2534L19.356 11.2398L19.5204 10.2534ZM19.5204 13.7466L19.356 12.7602L19.5204 13.7466ZM18.7459 13.8757L18.5815 12.8893C18.1979 12.9532 17.8862 13.2337 17.7823 13.6083L18.7459 13.8757ZM18.096 15.4433L17.2257 14.9507C17.0341 15.2891 17.0562 15.708 17.2823 16.0245L18.096 15.4433ZM18.5527 16.0827L17.739 16.6639V16.6639L18.5527 16.0827ZM16.0827 18.5528L16.6639 17.739L16.6639 17.739L16.0827 18.5528ZM15.4432 18.096L16.0244 17.2823C15.708 17.0562 15.2891 17.0342 14.9506 17.2258L15.4432 18.096ZM13.8757 18.7459L13.6083 17.7823C13.2337 17.8862 12.9532 18.1979 12.8893 18.5815L13.8757 18.7459ZM13.7466 19.5204L12.7602 19.356L13.7466 19.5204ZM10.2534 19.5204L11.2398 19.356L10.2534 19.5204ZM10.1243 18.7459L11.1107 18.5815C11.0468 18.1979 10.7663 17.8862 10.3917 17.7823L10.1243 18.7459ZM8.55676 18.096L9.04937 17.2258C8.71089 17.0342 8.29202 17.0562 7.97552 17.2823L8.55676 18.096ZM7.9173 18.5528L7.33606 17.739H7.33606L7.9173 18.5528ZM5.63604 18.364L4.92893 19.0711H4.92893L5.63604 18.364ZM5.44724 16.0827L4.6335 15.5015L5.44724 16.0827ZM5.90399 15.4432L6.71773 16.0245C6.9438 15.708 6.96584 15.2891 6.77425 14.9506L5.90399 15.4432ZM5.25414 13.8757L6.21774 13.6083C6.11378 13.2337 5.80207 12.9532 5.41854 12.8893L5.25414 13.8757ZM4.47959 13.7466L4.64399 12.7602H4.64399L4.47959 13.7466ZM4.47959 10.2534L4.31519 9.26701H4.31519L4.47959 10.2534ZM5.25414 10.1243L5.41854 11.1107C5.80207 11.0468 6.11379 10.7663 6.21774 10.3917L5.25414 10.1243ZM5.90398 8.55679L6.77423 9.0494C6.96583 8.71092 6.94378 8.29205 6.71771 7.97555L5.90398 8.55679ZM5.4472 7.91731L4.63347 8.49855H4.63347L5.4472 7.91731ZM5.636 5.63605L6.34311 6.34315H6.34311L5.636 5.63605ZM7.91727 5.44724L8.4985 4.63351V4.63351L7.91727 5.44724ZM8.55674 5.90401L7.9755 6.71774C8.292 6.94381 8.71087 6.96586 9.04935 6.77426L8.55674 5.90401ZM10.1243 5.25414L10.3917 6.21774C10.7663 6.11379 11.0468 5.80207 11.1107 5.41854L10.1243 5.25414ZM12 2C10.6456 2 9.48967 2.9792 9.26701 4.31519L11.2398 4.64399C11.3017 4.27237 11.6233 4 12 4V2ZM14.733 4.31519C14.5103 2.9792 13.3544 2 12 2V4C12.3767 4 12.6983 4.27237 12.7602 4.64399L14.733 4.31519ZM14.8621 5.08974L14.733 4.31519L12.7602 4.64399L12.8893 5.41854L14.8621 5.08974ZM13.6083 6.21774C14.0817 6.34907 14.5317 6.5371 14.9506 6.77425L15.9358 5.03374C15.3769 4.71736 14.7758 4.46611 14.143 4.29054L13.6083 6.21774ZM15.5015 4.6335L14.862 5.09026L16.0245 6.71773L16.6639 6.26097L15.5015 4.6335ZM19.0711 4.92893C18.1133 3.97121 16.6036 3.84626 15.5015 4.6335L16.6639 6.26097C16.9705 6.04199 17.3905 6.07675 17.6569 6.34315L19.0711 4.92893ZM19.3665 8.49854C20.1537 7.3964 20.0288 5.88665 19.0711 4.92893L17.6569 6.34315C17.9233 6.60954 17.958 7.02949 17.739 7.33606L19.3665 8.49854ZM18.9097 9.138L19.3665 8.49854L17.739 7.33606L17.2823 7.97552L18.9097 9.138ZM17.2258 9.04937C17.4629 9.46832 17.6509 9.91831 17.7823 10.3917L19.7095 9.85696C19.5339 9.22417 19.2826 8.62308 18.9663 8.06415L17.2258 9.04937ZM19.6848 9.26701L18.9103 9.13792L18.5815 11.1107L19.356 11.2398L19.6848 9.26701ZM22 12C22 10.6456 21.0208 9.48967 19.6848 9.26701L19.356 11.2398C19.7276 11.3017 20 11.6233 20 12H22ZM19.6848 14.733C21.0208 14.5103 22 13.3544 22 12H20C20 12.3767 19.7276 12.6983 19.356 12.7602L19.6848 14.733ZM18.9103 14.8621L19.6848 14.733L19.356 12.7602L18.5815 12.8893L18.9103 14.8621ZM17.7823 13.6083C17.6509 14.0817 17.4629 14.5317 17.2257 14.9507L18.9662 15.9359C19.2826 15.3769 19.5339 14.7758 19.7095 14.143L17.7823 13.6083ZM19.3665 15.5015L18.9097 14.862L17.2823 16.0245L17.739 16.6639L19.3665 15.5015ZM19.071 19.0711C20.0288 18.1134 20.1537 16.6036 19.3665 15.5015L17.739 16.6639C17.958 16.9705 17.9232 17.3905 17.6568 17.6569L19.071 19.0711ZM15.5014 19.3665C16.6036 20.1537 18.1133 20.0288 19.071 19.0711L17.6568 17.6569C17.3904 17.9233 16.9705 17.958 16.6639 17.739L15.5014 19.3665ZM14.862 18.9098L15.5014 19.3665L16.6639 17.739L16.0244 17.2823L14.862 18.9098ZM14.9506 17.2258C14.5317 17.4629 14.0817 17.6509 13.6083 17.7823L14.143 19.7095C14.7758 19.5339 15.3769 19.2826 15.9358 18.9663L14.9506 17.2258ZM14.733 19.6848L14.8621 18.9103L12.8893 18.5815L12.7602 19.356L14.733 19.6848ZM12 22C13.3544 22 14.5103 21.0208 14.733 19.6848L12.7602 19.356C12.6983 19.7276 12.3767 20 12 20V22ZM9.26701 19.6848C9.48967 21.0208 10.6456 22 12 22V20C11.6233 20 11.3017 19.7276 11.2398 19.356L9.26701 19.6848ZM9.13792 18.9103L9.26701 19.6848L11.2398 19.356L11.1107 18.5815L9.13792 18.9103ZM10.3917 17.7823C9.91831 17.6509 9.46832 17.4629 9.04937 17.2258L8.06415 18.9663C8.62308 19.2826 9.22417 19.5339 9.85696 19.7095L10.3917 17.7823ZM8.49854 19.3665L9.138 18.9097L7.97552 17.2823L7.33606 17.739L8.49854 19.3665ZM4.92893 19.0711C5.88665 20.0288 7.3964 20.1537 8.49854 19.3665L7.33606 17.739C7.02949 17.958 6.60954 17.9233 6.34315 17.6569L4.92893 19.0711ZM4.6335 15.5015C3.84626 16.6036 3.97121 18.1133 4.92893 19.0711L6.34315 17.6569C6.07675 17.3905 6.04199 16.9705 6.26097 16.6639L4.6335 15.5015ZM5.09026 14.862L4.6335 15.5015L6.26097 16.6639L6.71773 16.0245L5.09026 14.862ZM6.77425 14.9506C6.5371 14.5317 6.34907 14.0817 6.21774 13.6083L4.29054 14.143C4.46611 14.7758 4.71736 15.3769 5.03374 15.9358L6.77425 14.9506ZM4.31519 14.733L5.08974 14.8621L5.41854 12.8893L4.64399 12.7602L4.31519 14.733ZM2 12C2 13.3544 2.9792 14.5103 4.31519 14.733L4.64399 12.7602C4.27237 12.6983 4 12.3767 4 12H2ZM4.31519 9.26701C2.9792 9.48967 2 10.6456 2 12H4C4 11.6233 4.27237 11.3017 4.64399 11.2398L4.31519 9.26701ZM5.08974 9.13792L4.31519 9.26701L4.64399 11.2398L5.41854 11.1107L5.08974 9.13792ZM6.21774 10.3917C6.34907 9.91832 6.53709 9.46834 6.77423 9.0494L5.03372 8.06419C4.71735 8.62311 4.4661 9.22418 4.29054 9.85696L6.21774 10.3917ZM4.63347 8.49855L5.09024 9.13803L6.71771 7.97555L6.26094 7.33607L4.63347 8.49855ZM4.9289 4.92894C3.97118 5.88666 3.84623 7.39641 4.63347 8.49855L6.26094 7.33607C6.04196 7.0295 6.07671 6.60955 6.34311 6.34315L4.9289 4.92894ZM8.4985 4.63351C7.39637 3.84627 5.88662 3.97122 4.9289 4.92894L6.34311 6.34315C6.60951 6.07676 7.02946 6.042 7.33603 6.26098L8.4985 4.63351ZM9.13797 5.09028L8.4985 4.63351L7.33603 6.26098L7.9755 6.71774L9.13797 5.09028ZM9.04935 6.77426C9.4683 6.5371 9.9183 6.34907 10.3917 6.21774L9.85696 4.29054C9.22416 4.46611 8.62306 4.71737 8.06413 5.03376L9.04935 6.77426ZM9.26701 4.31519L9.13792 5.08974L11.1107 5.41854L11.2398 4.64399L9.26701 4.31519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "black",
    fill: "none",
    strokeWidth: 2
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "signout",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5L14 7C14 5.34315 12.6569 4 11 4L5 4C3.34315 4 2 5.34315 2 7L2 17C2 18.6569 3.34315 20 5 20L11 20C12.6569 20 14 18.6569 14 17L14 16.5",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16L23 12L19 8",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 12L14 12",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "sort",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16L12 20L16 16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8L12 4L16 8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "superuser",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 14L6.42174 21.1022C6.20531 22.0761 6.94643 23 7.94414 23V23C8.58184 23 9.1553 22.6118 9.39214 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14L15.5783 21.1022C15.7947 22.0761 15.0536 23 14.0559 23V23C13.4182 23 12.8447 22.6118 12.6079 22.0197L11 18",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8533 7.68297L11.6626 7.92638C11.2222 7.97531 10.7778 7.97531 10.3374 7.92638L8.14672 7.68297C7.09234 7.56582 6.03461 7.87231 5.20621 8.53503L4.11731 9.40615C2.72109 10.5231 2.60574 12.6057 3.87008 13.8701L4.75 14.75C5.44036 15.4404 6.55964 15.4404 7.25 14.75C7.94036 14.0596 7.94036 12.9404 7.25 12.25L6.5 11.5L8 11V14H14V11L15.5 11.5L14.75 12.25C14.0596 12.9404 14.0596 14.0596 14.75 14.75C15.4404 15.4404 16.5596 15.4404 17.25 14.75L18.1299 13.8701C19.3943 12.6057 19.2789 10.5231 17.8827 9.40615L16.7938 8.53503C15.9654 7.87231 14.9077 7.56582 13.8533 7.68297Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 4,
    r: 3,
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21H22L18 14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "trash",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7H18V19C18 20.1046 17.1046 21 16 21H8C6.89543 21 6 20.1046 6 19V7Z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7H20",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5C8 3.89543 8.89543 3 10 3H14C15.1046 3 16 3.89543 16 5V7H8V5Z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11V17",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11V17",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 16V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V16",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7L12 2L17 7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16V2",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43826 13.5728L8.00915 12.7518L7.53399 12.4214L7.01079 12.6688L7.43826 13.5728ZM16.5617 13.5728L16.9892 12.6688L16.466 12.4214L15.9909 12.7518L16.5617 13.5728ZM5 19C5 17.0038 6.16982 15.2788 7.86573 14.4768L7.01079 12.6688C4.64206 13.7888 3 16.2017 3 19H5ZM6 20C5.44772 20 5 19.5523 5 19H3C3 20.6569 4.34315 22 6 22V20ZM12 20H6V22H12V20ZM18 20H12V22H18V20ZM19 19C19 19.5523 18.5523 20 18 20V22C19.6569 22 21 20.6569 21 19H19ZM16.1343 14.4768C17.8302 15.2788 19 17.0038 19 19H21C21 16.2017 19.3579 13.7888 16.9892 12.6688L16.1343 14.4768ZM15.9909 12.7518C14.859 13.5388 13.4849 14 12 14V16C13.9061 16 15.6765 15.4063 17.1326 14.3938L15.9909 12.7518ZM12 14C10.5151 14 9.14096 13.5388 8.00915 12.7518L6.86737 14.3938C8.3235 15.4063 10.0939 16 12 16V14Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4,
    fill: "none",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.c4ede150bb1c3ffe0a7e0e13bea9bd20.svg";
export { ForwardRef as ReactComponent };